angular.module('bizmetryApp').controller('BizInterceptorsTabController', function (
    $scope, $mdDialog, $mdToast, $timeout, $interval,
    BizInterceptorService, ConfigurationService, dialogService
) {

    // ========================================
    // INICIALIZACIÓN
    // ========================================

    $scope.loadingBizInterceptors = false;
    $scope.filteredBizInterceptors = [];

    $scope.bizInterceptor = {
        totalItems: 0,
        page: 0,
        totalPages: 0,
        pageSize: 10,
        pageSizeOptions: [5, 10, 15, 25, 50, 100],
        searchDebounce: ConfigurationService.getFromCache('frontend.search_debounce_time') || 1000,
        // The last four options sort by a value that isn't a persisted
        // column on BizInterceptor (captured/dropped/pressure are only ever
        // computed per-row from each interceptor's own time-series data) —
        // the backend detects these by field name and switches to an
        // in-memory sort-then-paginate path instead of its normal DB-level
        // Pageable sort. Same shared BizInterceptorServiceImpl the
        // account-wide Interceptors Panel already uses — see
        // BizInterceptorServiceImpl#COMPUTED_SORT_FIELDS.
        sortOptions: [
            { value: 'name_asc', label: 'Name (A-Z)', field: 'biz_interceptor_name', dir: 'asc' },
            { value: 'name_desc', label: 'Name (Z-A)', field: 'biz_interceptor_name', dir: 'desc' },
            { value: 'date_asc', label: 'Oldest First', field: 'created_ts', dir: 'asc' },
            { value: 'date_desc', label: 'Newest First', field: 'created_ts', dir: 'desc' },
            { value: 'captured_desc', label: 'Most Captured', field: 'total_frames_captured', dir: 'desc' },
            { value: 'captured_asc', label: 'Least Captured', field: 'total_frames_captured', dir: 'asc' },
            { value: 'dropped_desc', label: 'Most Dropped', field: 'total_frames_dropped', dir: 'desc' },
            { value: 'pressure_desc', label: 'Highest Avg Pressure', field: 'avg_load_pressure', dir: 'desc' }
        ],
        selectedSort: 'name_asc',
        search: '',
        // Server-side filter (see BizInterceptorServiceImpl's live-filter
        // path, sibling to COMPUTED_SORT_FIELDS) — only interceptors with
        // at least one ONLINE environment come back from the API when this
        // is on; off shows everything, same as today.
        liveOnly: false,
        transportType: ''       // interceptor transport_type; empty = all
    };

    // Transport filter options — every transport in reference data, implemented or not
    $scope.transportOptions = [];
    BizInterceptorService.getTransportTypes()
        .then(function (types) { $scope.transportOptions = types; })
        .catch(function (error) { console.error('[BizInterceptorsTab] Error loading transport types:', error); });

    // Row badge. Rows created before transport_type existed come back as REST_API (see BizInterceptorDTO#fromEntity).
    $scope.getInterceptorTransport = function (ic) {
        return BizInterceptorService.describeTransport((ic && ic.transport_type) || 'REST_API');
    };

    // ========================================
    // SEARCH (debounced)
    // ========================================

    var searchTimeout;

    $scope.debouncedBizInterceptorSearch = function () {
        if (searchTimeout) { $timeout.cancel(searchTimeout); }
        searchTimeout = $timeout(function () {
            $scope.onBizInterceptorNavBarChange();
        }, $scope.bizInterceptor.searchDebounce);
    };

    // The search box's own "×" — a single deliberate click, not a
    // keystroke — should clear and reload immediately rather than sitting
    // through the same debounce meant to smooth out typing (see the
    // account-wide Interceptors Panel's own clearSearch for the same fix).
    $scope.clearBizInterceptorSearch = function () {
        if (searchTimeout) { $timeout.cancel(searchTimeout); }
        $scope.bizInterceptor.search = '';
        $scope.onBizInterceptorNavBarChange();
    };

    // ========================================
    // PAGINACIÓN
    // ========================================

    $scope.onBizInterceptorPageDown = function () {
        if ($scope.bizInterceptor.page > 0) {
            $scope.bizInterceptor.page--;
            $scope.loadBizInterceptors();
        }
    };

    $scope.onBizInterceptorPageUp = function () {
        if ($scope.bizInterceptor.page < $scope.bizInterceptor.totalPages - 1) {
            $scope.bizInterceptor.page++;
            $scope.loadBizInterceptors();
        }
    };

    $scope.onBizInterceptorPageSizeChange = function () {
        $scope.bizInterceptor.page = 0;
        $scope.loadBizInterceptors();
    };

    // ========================================
    // HELPERS DE SORT
    // ========================================

    function resolveSort() {
        var opt = $scope.bizInterceptor.sortOptions.find(function (o) {
            return o.value === $scope.bizInterceptor.selectedSort;
        });
        return opt ? { field: opt.field, dir: opt.dir } : { field: 'biz_interceptor_name', dir: 'asc' };
    }

    // ========================================
    // CARGAR BIZ INTERCEPTORS
    // ========================================
    // Environment live status (green/red per environment) comes precomputed
    // from the backend as ic.environments[].live_status — see
    // BizInterceptorServiceImpl#buildEnvironmentsResponse for the rules
    // (interceptor online + environment enabled + agent online + interceptor
    // enabled + profile enabled). No client-side derivation needed.

    // `silent`: used by the auto-refresh poll below — skips the spinner and
    // doesn't blank the list while the request is in flight, so the row
    // data just swaps in place every few seconds instead of flickering.
    //
    // requestSeq guards against the silent auto-refresh interval (fires
    // independently every biz_interceptors_refresh_interval) and a
    // debounced search/filter call landing out of order — e.g. a refresh
    // tick issued just before the user typed, still in flight with the OLD
    // search text, resolving AFTER the search's own (correctly filtered)
    // response already rendered would silently overwrite it with the
    // stale, unfiltered list. Only the response whose sequence number
    // still matches the latest call is ever applied — same fix as the
    // account-wide Interceptors Panel's own loadInterceptors.
    var requestSeq = 0;
    var listDestroyed = false;

    $scope.loadBizInterceptors = function (silent) {
        if (listDestroyed || BizInterceptorService.isListRefreshPaused()) return;
        if (!$scope.profile || !$scope.profile.id) { return; }

        if (!silent) {
            $scope.loadingBizInterceptors = true;
            $scope.filteredBizInterceptors = [];
        }

        var sort = resolveSort();
        var mySeq = ++requestSeq;

        BizInterceptorService.listByProfile($scope.profile.id, {
            pauseWithMetrics: true,
            page: $scope.bizInterceptor.page,
            size: $scope.bizInterceptor.pageSize,
            search: $scope.bizInterceptor.search,
            sortField: sort.field,
            sortDir: sort.dir,
            liveOnly: $scope.bizInterceptor.liveOnly,
            transportType: $scope.bizInterceptor.transportType || null,
            // silent (this function's own param) already means "don't show
            // the local loadingBizInterceptors flag" — skipLoader piggybacks
            // on the same flag to also suppress the GLOBAL LoadingHttpInterceptor
            // spinner for the same silent auto-refresh tick (see that
            // interval below), without changing anything for a real,
            // user-initiated (non-silent) load.
            skipLoader: !!silent
        })
            .then(function (response) {
                if (mySeq !== requestSeq || BizInterceptorService.isListRefreshPaused()) { return; } // superseded or covered by Metrics Explorer

                var data = response && response.data;
                $scope.filteredBizInterceptors = (data && data.content) || [];
                rememberRows($scope.filteredBizInterceptors);
                syncSelectionStateToCurrentPage();
                $scope.bizInterceptor.totalPages = (data && data.totalPages) || 0;
                $scope.bizInterceptor.totalItems = (data && data.totalElements) || 0;
                $scope.bizInterceptor.page = (data && data.page) || 0;

                if ($scope.bizInterceptor.page >= $scope.bizInterceptor.totalPages && $scope.bizInterceptor.totalPages > 0) {
                    $scope.bizInterceptor.page = $scope.bizInterceptor.totalPages - 1;
                }
            })
            .catch(function (error) {
                if (error && error.status === -1) return;
                if (mySeq !== requestSeq || BizInterceptorService.isListRefreshPaused()) { return; } // superseded or covered by Metrics Explorer

                if (error && error.status === 204) {
                    $scope.filteredBizInterceptors = [];
                    return;
                }
                console.error('[BizInterceptorsTab] Error loading biz interceptors:', error);
                if (!silent) { $scope.filteredBizInterceptors = []; }
            })
            .finally(function () {
                if (mySeq !== requestSeq) { return; } // superseded by a newer call — discard

                $scope.loadingBizInterceptors = false;
            });
    };

    // ========================================
    // CAMBIO DE FILTROS
    // ========================================

    $scope.onBizInterceptorNavBarChange = function () {
        $scope.bizInterceptor.page = 0;
        $scope.loadBizInterceptors();
    };

    $scope.onBizInterceptorLiveOnlyChange = function () {
        $scope.bizInterceptor.page = 0;
        $scope.loadBizInterceptors();
    };

    // ========================================
    // CREAR BIZ INTERCEPTOR
    // ========================================

    $scope.createNewBizInterceptor = function () {
        $mdDialog.show({
            controller: 'CreateBizInterceptorDialogController',
            controllerAs: 'vm',
            templateUrl: 'profile/tabs/biz-interceptors/create-dialog/create-biz-interceptor-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            escapeToClose: false,
            multiple: true,
            locals: { profile: $scope.profile }
        }).then(function (created) {
            if (created) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Biz interceptor created successfully')
                        .position('top right')
                        .hideDelay(3000)
                );
                $scope.loadBizInterceptors();
            }
        }).catch(angular.noop);
    };

    // ========================================
    // EDITAR BIZ INTERCEPTOR — full wizard (General + Environments),
    // mirrors Edit Biz Event's dialog-open/full-reload pattern. The quick
    // inline click-to-edit on the name/description cells below is
    // untouched — this is the entry point for everything else.
    // ========================================

    $scope.openEditBizInterceptorDialog = function ($event, interceptor) {
        if ($event) { $event.stopPropagation(); }
        $scope._listRefreshPaused = true;
        $mdDialog.show({
            controller: 'EditBizInterceptorDialogController',
            controllerAs: 'vm',
            templateUrl: 'profile/tabs/biz-interceptors/edit-wizard/edit-biz-interceptor-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            escapeToClose: false,
            multiple: true,
            locals: { interceptor: interceptor, profile: $scope.profile }
        }).then(function (result) {
            if (result && result.updated) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Biz interceptor updated successfully')
                        .position('top right')
                        .hideDelay(3000)
                );
                $scope.loadBizInterceptors(); // full reload, mirrors Edit Biz Event — not a local row mutation
            }
        }).catch(angular.noop).finally(function () {
            $scope._listRefreshPaused = false;
        });
    };

    // ========================================
    // METRICS EXPLORER — time-series charts (captured/uploaded/dropped/
    // filtered frames, received/uploaded bytes) for one interceptor,
    // pre-scoped to the environment whose live-status dot was clicked
    // (switchable to any other environment, or "All Environments"
    // combined, from within the dialog itself). Replaced the old
    // read-only InterceptorStatsDialogController as the dot's click
    // target — Consolidated Stats already covers the plain-counter view
    // that used to show.
    // ========================================

    // ========================================
    // ENVIRONMENT STATUS DOT — green/yellow/purple/red, driven by the
    // server-computed env.display_status (see BizInterceptorEnvironmentDTO /
    // BizInterceptorServiceImpl#buildEnvironmentsResponse). Kept as
    // functions rather than inline ng-class/tooltip ternaries once a 4th
    // state (AGENT_UNREACHABLE) needed its own tooltip text pulled from a
    // nested, possibly-null field.
    // ========================================

    var ENV_DOT_CLASS_BY_STATUS = {
        ONLINE: 'bi-env-live-dot--on',
        STANDBY: 'bi-env-live-dot--warn',
        STALLED: 'bi-env-live-dot--stalled',
        AGENT_UNREACHABLE: 'bi-env-live-dot--agent-unreachable',
        OFFLINE: 'bi-env-live-dot--off'
    };

    $scope.envDotClass = function (env) {
        return ENV_DOT_CLASS_BY_STATUS[env.display_status] || 'bi-env-live-dot--off';
    };

    // ── SLA alert ring — is THIS environment currently mid-breach for
    // pressure or agent latency? Same per-environment_id lookup as
    // ConsolidatedStatsDialogController/EnvironmentStatusDialogController's
    // own findEnvAlert, just reduced to a boolean here since the dot only
    // needs to know whether to show the alert ring, not since when. This
    // boolean itself is independent of display_status — still used as-is for
    // envDotTooltip's "⚠ SLA alert active" text, so an offline/standby
    // environment sitting on a stale SET_CONDITION is still visible on
    // hover. The pulsing --alert ring specifically is gated to ONLINE-only
    // at the call site (biz-interceptors-tab.html's ng-class) — a blinking
    // ring on a dot that's already showing off/gray otherwise reads as
    // confusing noise, per product feedback. ──
    function envMetricAlertActive(metricConfig, environmentId) {
        if (!metricConfig || !metricConfig.environment_statuses || !environmentId) { return false; }
        return metricConfig.environment_statuses.some(function (s) {
            return s.environment_id === environmentId && s.status === 'SET_CONDITION';
        });
    }

    $scope.envHasAlert = function (ic, env) {
        if (typeof env.alert_active === 'boolean') { return env.alert_active; }
        var mc = (ic && ic.monitoring_config) || {};
        return envMetricAlertActive(mc.pressure, env.id) || envMetricAlertActive(mc.agent_latency, env.id);
    };

    $scope.envDotTooltip = function (ic, env) {
        var label;
        switch (env.display_status) {
            case 'ONLINE':
                label = env.env_name + ': Live';
                break;
            case 'STANDBY':
                label = env.env_name + ': Online, not live';
                break;
            case 'STALLED':
                label = env.env_name + ': Stalled — agent not taking uploads (offline or full), uploads paused';
                break;
            case 'AGENT_UNREACHABLE':
                var connectionError = env.agent_connection_error || (env.stats && env.stats.agent_connection && env.stats.agent_connection.agent_connection_error);
                label = env.env_name + ': Disconnected from agent' + (connectionError ? ' — ' + connectionError : '');
                break;
            default:
                label = env.env_name + ': Offline';
        }
        return $scope.envHasAlert(ic, env) ? (label + ' — ⚠ SLA alert active') : label;
    };

    // The interceptor-wide "Average Pressure" bar shown next to the
    // environment dots — ic.avg_load_pressure is already the real average
    // across all of this interceptor's environments combined, computed
    // server-side (see BizInterceptorServiceImpl#applyEnvironments /
    // resolveAvgLoadPressure with a null environmentId), same field
    // Consolidated Stats' own General-tab badge reads.
    $scope.avgLoadPressureLabel = function (ic) {
        if (!ic || ic.avg_load_pressure === null || ic.avg_load_pressure === undefined) { return '—'; }
        return Math.round(ic.avg_load_pressure) + '%';
    };

    // Same shape, for the interceptor-wide Avg Ping Time reading now shown
    // alongside Captured/Dropped in the Traffic column.
    $scope.avgPingTimeLabel = function (ic) {
        if (!ic || ic.avg_ping_time_ms === null || ic.avg_ping_time_ms === undefined) { return '—'; }
        return Math.round(ic.avg_ping_time_ms) + 'ms';
    };

    // Row-level action (Actions column) — opens Metrics Explorer scoped to
    // "all environments" (MetricsExplorerDialogController defaults to that
    // when environment is null/undefined), since this button isn't tied to
    // any one environment's dot the way it used to be.
    $scope.openMetricsExplorerDialog = function ($event, interceptor, environment) {
        if ($event) { $event.stopPropagation(); }
        $scope._listRefreshPaused = true;
        var releaseRefresh = BizInterceptorService.pauseListRefresh();
        return $mdDialog.show({
            controller: 'MetricsExplorerDialogController',
            templateUrl: 'profile/tabs/biz-interceptors/metrics-explorer-dialog/metrics-explorer-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            escapeToClose: true,
            multiple: true,
            resolve: {
                interceptor: function () {
                    return BizInterceptorService.getById(interceptor.biz_interceptor_id).then(function (response) { return response.data; });
                }
            },
            locals: { environment: environment }
        }).catch(angular.noop).finally(function () {
            releaseRefresh();
            $scope._listRefreshPaused = false;
            if (!listDestroyed) $scope.loadBizInterceptors(true);
        });
    };

    // Environment status dot click — same dialog for all 4 states
    // (EnvironmentStatusDialogController: duration in current state, plus a
    // Details section that varies by display_status — capture counters for
    // ONLINE, none for OFFLINE, the specific standby_reasons for STANDBY, or
    // the connection error + stack trace for AGENT_UNREACHABLE). Uniform on
    // purpose — this used to open a visually different dialog just for
    // AGENT_UNREACHABLE (still true for Consolidated Stats' own "Down"
    // badge, via AgentConnectionErrorDialogController, unaffected here).
    $scope.openEnvironmentDialog = function ($event, interceptor, env) {
        if ($event) { $event.stopPropagation(); }
        var detailPromise = BizInterceptorService.getById(interceptor.biz_interceptor_id)
            .then(function (response) { return response.data; });
        $mdDialog.show({
            controller: 'EnvironmentStatusDialogController',
            controllerAs: 'vm',
            templateUrl: 'profile/tabs/biz-interceptors/environment-status-dialog/environment-status-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            escapeToClose: true,
            multiple: true,
            resolve: {
                env: function () {
                    return detailPromise.then(function (detail) {
                        return (detail.environments || []).find(function (item) { return item.id === env.id; }) || env;
                    });
                },
                monitoringConfig: function () {
                    return detailPromise.then(function (detail) { return detail.monitoring_config; });
                }
            },
            locals: {
                bizInterceptorId: interceptor.biz_interceptor_id,
                bizInterceptorName: interceptor.biz_interceptor_name
            }
        }).catch(angular.noop);
    };

    // ========================================
    // CONSOLIDATED STATS — same data as the per-environment stats dialog,
    // aggregated client-side across every environment of ic.environments[]
    // (sum of general counters, operations merged/summed by operation_id,
    // one status row per environment since status/heartbeat/agent don't
    // sum the way counters do). No dedicated summary endpoint — the list
    // detail is fetched on demand before opening the dialog.
    // ========================================

    $scope.openConsolidatedStatsDialog = function ($event, interceptor) {
        if ($event) { $event.stopPropagation(); }
        $scope._listRefreshPaused = true;
        $mdDialog.show({
            controller: 'ConsolidatedStatsDialogController',
            controllerAs: 'vm',
            templateUrl: 'profile/tabs/biz-interceptors/consolidated-stats-dialog/consolidated-stats-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            escapeToClose: true,
            multiple: true,
            resolve: {
                interceptor: function () {
                    return BizInterceptorService.getById(interceptor.biz_interceptor_id).then(function (response) { return response.data; });
                }
            }
        }).catch(angular.noop).finally(function () {
            $scope._listRefreshPaused = false;
        });
    };

    // ========================================
    // DOWNLOAD ARTIFACT — opens the Interceptor Download dialog (environment
    // picker + Download button, with a spinner while the backend fetches/
    // repackages the artifact from Nexus).
    // ========================================

    $scope.openDownloadArtifactDialog = function ($event, interceptor) {
        if ($event) { $event.stopPropagation(); }
        $mdDialog.show({
            controller: 'InterceptorDownloadDialogController',
            controllerAs: 'vm',
            templateUrl: 'profile/tabs/biz-interceptors/interceptor-download-dialog/interceptor-download-dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            escapeToClose: true,
            multiple: true,
            locals: { interceptor: interceptor, bundle: null }
        }).catch(angular.noop);
    };

    // ========================================
    // TOGGLE ENABLE/DISABLE
    // ========================================

    $scope.onToggleBizInterceptorEnabled = function (interceptor) {
        BizInterceptorService.patch(interceptor.biz_interceptor_id, { enabled: interceptor.enabled })
            .then(function () {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Biz interceptor ' + (interceptor.enabled ? 'enabled' : 'disabled'))
                        .position('top right')
                        .hideDelay(2000)
                );
                // live_status is server-computed from (among other things)
                // this same enabled flag — a silent reload picks up the
                // recalculated value instead of leaving the env dots showing
                // whatever they were before the toggle.
                $scope.loadBizInterceptors(true);
            })
            .catch(function (error) {
                interceptor.enabled = !interceptor.enabled; // revert on error
                console.error('[BizInterceptorsTab] Error toggling enabled:', error);
                dialogService.showErrorDialog(
                    'Update Failed',
                    (error.data && error.data.message) || 'Could not update biz interceptor.'
                );
            });
    };

    // ========================================
    // INLINE EDIT — name + description in-row
    // ========================================

    $scope.inlineEdit = {};        // 'name' | 'desc' | null — active field, keyed by biz_interceptor_id
    $scope.inlineDraft = {};       // { name, desc } draft values
    $scope.inlineNameError = {};   // error message string | null

    $scope.startInlineEdit = function ($event, interceptor, field) {
        $event.stopPropagation();
        var id = interceptor.biz_interceptor_id;
        $scope.inlineDraft[id] = $scope.inlineDraft[id] || {};
        $scope.inlineDraft[id].name = interceptor.biz_interceptor_name;
        $scope.inlineDraft[id].desc = interceptor.biz_interceptor_description || '';
        $scope.inlineNameError[id] = null;
        $scope.inlineEdit[id] = field;
    };

    $scope.onInlineNameChange = function (interceptor) {
        var id = interceptor.biz_interceptor_id;
        var draft = $scope.inlineDraft[id];
        var candidate = (draft && draft.name || '').trim();

        if (!candidate) {
            $scope.inlineNameError[id] = 'Name is required';
            return;
        }
        var duplicate = $scope.filteredBizInterceptors.some(function (i) {
            return i.biz_interceptor_id !== id &&
                (i.biz_interceptor_name || '').trim().toLowerCase() === candidate.toLowerCase();
        });
        $scope.inlineNameError[id] = duplicate ? 'An interceptor with this name already exists' : null;
    };

    $scope.inlineNameInvalid = function (interceptor) {
        var id = interceptor.biz_interceptor_id;
        var draft = $scope.inlineDraft[id];
        var candidate = (draft && draft.name || '').trim();
        if (!candidate) { return true; }
        return !!$scope.inlineNameError[id];
    };

    $scope.commitInlineEdit = function (interceptor, field) {
        var id = interceptor.biz_interceptor_id;
        var draft = $scope.inlineDraft[id];

        if (!draft) { $scope.inlineEdit[id] = null; return; }

        var newName = (draft.name || '').trim();
        var newDesc = (draft.desc || '').trim();

        if (field === 'name' && $scope.inlineNameInvalid(interceptor)) {
            return; // keep input open so the user must fix it
        }

        $scope.inlineEdit[id] = null;

        if (newName === interceptor.biz_interceptor_name &&
            newDesc === (interceptor.biz_interceptor_description || '')) {
            return; // nothing changed
        }

        BizInterceptorService.patch(id, {
            biz_interceptor_name: newName,
            biz_interceptor_description: newDesc
        }).then(function () {
            interceptor.biz_interceptor_name = newName;
            interceptor.biz_interceptor_description = newDesc;
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Biz interceptor updated')
                    .position('top right')
                    .hideDelay(2000)
            );
        }).catch(function (err) {
            dialogService.showErrorDialog('Update Failed',
                (err.data && err.data.message) || 'Could not update biz interceptor.');
        });
    };

    $scope.cancelInlineEdit = function (interceptor) {
        var id = interceptor.biz_interceptor_id;
        $scope.inlineEdit[id] = null;
        $scope.inlineNameError[id] = null;
    };

    $scope.onInlineKeydown = function ($event, interceptor, field) {
        if ($event.key === 'Enter') {
            $event.preventDefault();
            if (field === 'name' && $scope.inlineNameInvalid(interceptor)) { return; }
            $event.target.blur();
        }
        if ($event.key === 'Escape') {
            $event.preventDefault();
            $scope.cancelInlineEdit(interceptor);
        }
        if ($event.key === 'Tab' && !$event.shiftKey && field === 'name') {
            $event.preventDefault();
            if ($scope.inlineNameInvalid(interceptor)) { return; }
            $scope.inlineEdit[interceptor.biz_interceptor_id] = 'desc';
        }
    };

    // ========================================
    // ELIMINAR — doble clic con ícono titilante + showConfirmationDialog
    // ========================================

    $scope.confirmDeleteBizInterceptorMap = {};
    $scope.deleteBizInterceptorTimers = {};
    var CONFIRM_TIMEOUT_MS = 3000;

    // Clones the interceptor's configuration as "Copy of <name>" (created disabled,
    // with its own service account and no stats).
    $scope.cloningBizInterceptorMap = {};
    $scope.cloneBizInterceptor = function (interceptor) {
        var id = interceptor.biz_interceptor_id;
        if ($scope.cloningBizInterceptorMap[id]) { return; }
        $scope.cloningBizInterceptorMap[id] = true;

        BizInterceptorService.clone(id)
            .then(function (response) {
                var copy = response.data || {};
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Biz interceptor copied as ' + (copy.biz_interceptor_name || 'a new interceptor'))
                        .position('top right')
                        .hideDelay(3000)
                );
                $scope.loadBizInterceptors();
            })
            .catch(function (err) {
                dialogService.showErrorDialog(
                    'Copy Failed',
                    dialogService.formatErrorMessage({
                        error: (err.data && err.data.error) || 'Copy Error',
                        message: (err.data && err.data.message) || 'Could not copy the biz interceptor.',
                        path: (err.data && err.data.path) || '/v1/api/bizmetry-biz-events/biz-interceptor/' + id + '/clone',
                        timestamp: (err.data && err.data.timestamp) || new Date().toISOString()
                    })
                );
            })
            .finally(function () { delete $scope.cloningBizInterceptorMap[id]; });
    };

    // Can't be deleted while it's online (any display status but OFFLINE) in some
    // environment — the backend refuses it too (409). null when it can.
    $scope.deleteBlockedReason = function (interceptor) {
        var online = (interceptor.environments || []).filter(function (env) {
            return env.display_status && env.display_status !== 'OFFLINE';
        }).map(function (env) { return env.env_name || env.name || env.id; });
        if (!online.length) { return null; }
        return 'Still online in ' + online.join(', ') +
            ' — stop it until it\'s offline in every environment to delete it';
    };

    $scope.deleteBizInterceptor = function (interceptor) {
        var id = interceptor.biz_interceptor_id;
        if ($scope.deleteBlockedReason(interceptor)) { return; }

        if (!$scope.confirmDeleteBizInterceptorMap[id]) {
            $scope.confirmDeleteBizInterceptorMap[id] = true;

            if ($scope.deleteBizInterceptorTimers[id]) {
                $timeout.cancel($scope.deleteBizInterceptorTimers[id]);
            }
            $scope.deleteBizInterceptorTimers[id] = $timeout(function () {
                $scope.confirmDeleteBizInterceptorMap[id] = false;
                delete $scope.deleteBizInterceptorTimers[id];
            }, CONFIRM_TIMEOUT_MS);

        } else {
            $timeout.cancel($scope.deleteBizInterceptorTimers[id]);
            delete $scope.deleteBizInterceptorTimers[id];
            $scope.confirmDeleteBizInterceptorMap[id] = false;

            dialogService.showConfirmationDialog(
                'Delete Biz Interceptor',
                'You are about to permanently delete <strong>' + interceptor.biz_interceptor_name +
                    '</strong>. This action cannot be undone.',
                interceptor.biz_interceptor_name,
                true
            ).then(function (decision) {
                if (decision !== 'confirmed') { return; }

                BizInterceptorService.delete(id)
                    .then(function () {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Biz interceptor deleted successfully')
                                .position('top right')
                                .hideDelay(3000)
                        );
                        $scope.loadBizInterceptors();
                    })
                    .catch(function (err) {
                        console.error('[BizInterceptorsTab] Delete error:', err);
                        dialogService.showErrorDialog(
                            'Delete Failed',
                            (err.data && err.data.message) || 'Could not delete biz interceptor.'
                        );
                    });
            });
        }
    };

    // ========================================
    // BULK SELECTION STATE — same pattern as the Resources tab
    // ========================================

    $scope.selectedBizInterceptorIds = new Set();

    // Contador reactivo — Angular no detecta mutaciones en Set,
    // pero sí detecta cambios en primitivos del $scope.
    // Referenciarlo en ng-checked fuerza re-evaluación en cada add/remove.
    $scope._selectedCount = 0;

    // selectionState: mapa id→boolean para los md-checkbox de la página actual
    $scope.selectionState = {};

    function addSelection(id) {
        if (!$scope.selectedBizInterceptorIds.has(id)) {
            $scope.selectedBizInterceptorIds.add(id);
            $scope._selectedCount++;
        }
    }

    function removeSelection(id) {
        if ($scope.selectedBizInterceptorIds.has(id)) {
            $scope.selectedBizInterceptorIds.delete(id);
            $scope._selectedCount--;
        }
    }

    // Latest row seen of each interceptor (selections span pages): what tells
    // whether a selected one on another page is still online.
    var lastSeenRows = {};
    function rememberRows(rows) {
        (rows || []).forEach(function (ic) { lastSeenRows[ic.biz_interceptor_id] = ic; });
    }

    // Delete All stays disabled while any selected interceptor is online. null when it can.
    $scope.bulkDeleteBlockedReason = function () {
        if (!$scope._selectedCount) { return null; }
        var online = Array.from($scope.selectedBizInterceptorIds).map(function (id) {
            return lastSeenRows[id];
        }).filter(function (ic) {
            return ic && $scope.deleteBlockedReason(ic);
        }).map(function (ic) { return ic.biz_interceptor_name; });
        if (!online.length) { return null; }
        return (online.length === 1 ? online[0] + ' is' : online.join(', ') + ' are') +
            ' still online — unselect ' + (online.length === 1 ? 'it' : 'them') +
            ', or stop ' + (online.length === 1 ? 'it' : 'them') + ' until offline in every environment';
    };

    function syncSelectionStateToCurrentPage() {
        $scope.selectionState = {};
        ($scope.filteredBizInterceptors || []).forEach(function (ic) {
            $scope.selectionState[ic.biz_interceptor_id] = $scope.selectedBizInterceptorIds.has(ic.biz_interceptor_id);
        });
    }

    function areAllCurrentPageSelected() {
        var page = $scope.filteredBizInterceptors || [];
        return page.length > 0 && page.every(function (ic) {
            return $scope.selectedBizInterceptorIds.has(ic.biz_interceptor_id);
        });
    }

    $scope.areAllCurrentPageSelected = areAllCurrentPageSelected;

    $scope.isBizInterceptorSelected = function (id) {
        return $scope.selectedBizInterceptorIds.has(id);
    };

    $scope.getSelectedCount = function () {
        return $scope._selectedCount;
    };

    $scope.onBizInterceptorCheckboxChange = function (id) {
        if ($scope.selectionState[id]) {
            addSelection(id);
        } else {
            removeSelection(id);
        }
    };

    // Checkbox de cabecera: selecciona / deselecciona la página actual
    $scope.onHeaderCheckboxClick = function () {
        var shouldSelectAll = !areAllCurrentPageSelected();
        ($scope.filteredBizInterceptors || []).forEach(function (ic) {
            if (shouldSelectAll) {
                addSelection(ic.biz_interceptor_id);
            } else {
                removeSelection(ic.biz_interceptor_id);
            }
            $scope.selectionState[ic.biz_interceptor_id] = shouldSelectAll;
        });
    };

    $scope.clearSelection = function () {
        $scope.selectedBizInterceptorIds.clear();
        $scope._selectedCount = 0;
        $scope.selectionState = {};
    };

    // ========================================
    // DELETE ALL — the selected interceptors
    // ========================================

    $scope.deleteAllSelected = function () {
        var count = $scope._selectedCount;
        if (count === 0 || $scope.bulkDeleteBlockedReason()) { return; }

        // Same type-to-confirm dialog as the single Delete; the text to type is the count.
        var label = count + ' biz interceptor' + (count !== 1 ? 's' : '');
        dialogService.showConfirmationDialog(
            'Delete ' + label,
            'You are about to permanently delete <strong>' + label + '</strong>, with ' +
                (count !== 1 ? 'their service accounts' : 'its service account') + '. ' +
                'This action cannot be undone.',
            label,
            true
        ).then(function (decision) {
            if (decision !== 'confirmed') { return; }

            var ids = Array.from($scope.selectedBizInterceptorIds);

            BizInterceptorService.bulkDeleteByIds(ids)
                .then(function (response) {
                    var data = response.data || {};
                    var deleted = data.deleted_count !== undefined ? data.deleted_count : ids.length;
                    var failed = data.failed_count || 0;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(deleted + ' biz interceptor' + (deleted !== 1 ? 's' : '') + ' deleted successfully' +
                                (failed ? ' (' + failed + ' could not be deleted)' : ''))
                            .position('top right')
                            .hideDelay(4000)
                    );

                    $scope.clearSelection();
                    $scope.loadBizInterceptors();
                })
                .catch(function (error) {
                    console.error('[BizInterceptorsTab] Bulk delete error:', error);
                    dialogService.showErrorDialog(
                        'Bulk Delete Failed',
                        (error.data && error.data.message) || 'An unexpected error occurred during bulk deletion.'
                    );
                });
        });
    };

    // ========================================
    // DOWNLOAD SELECTED — opens the Interceptor Download dialog in bundle mode:
    // pick ONE environment, get interceptor-bundle-<profile name>-<environment>-<currentTimeMillis>.zip
    // with a folder per selected interceptor holding its artifact for that environment.
    // ========================================

    $scope.downloadSelected = function ($event) {
        if ($scope._selectedCount === 0) { return; }
        var profile = $scope.profile || {};
        $mdDialog.show({
            controller: 'InterceptorDownloadDialogController',
            controllerAs: 'vm',
            templateUrl: 'profile/tabs/biz-interceptors/interceptor-download-dialog/interceptor-download-dialog.html',
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: true,
            escapeToClose: true,
            multiple: true,
            locals: {
                interceptor: null,
                bundle: {
                    ids: Array.from($scope.selectedBizInterceptorIds),
                    profileName: profile.profileName || profile.name,
                    environments: (profile.environments || []).map(function (env) {
                        return { id: env.id, env_name: env.name };
                    })
                }
            }
        }).catch(angular.noop);
    };

    // ========================================
    // CLEANUP
    // ========================================

    $scope.$on('$destroy', function () {
        listDestroyed = true;
        if (searchTimeout) { $timeout.cancel(searchTimeout); }
        Object.keys($scope.deleteBizInterceptorTimers || {}).forEach(function (k) {
            $timeout.cancel($scope.deleteBizInterceptorTimers[k]);
        });
        if (autoRefreshTimer) { $interval.cancel(autoRefreshTimer); }
    });

    // ========================================
    // AUTO-REFRESH — live_status/stats come from the Agent's periodic sync,
    // so this list can go stale just sitting on screen. Interval is
    // configuration-driven (frontend.biz_interceptors_refresh_interval,
    // central-config ConfigMap on bizmetry-shared-services), not hardcoded.
    //
    // md-tabs' `md-enable-disconnect` only disconnects the inactive tab's
    // scope from the digest/event tree — it never destroys it — so the
    // `ng-if="selectedTabIndex === 7"` guard in profile-details-dialog.html
    // never gets to re-evaluate once we leave this tab, and $destroy below
    // never fires. So the tick itself has to re-check that this tab is
    // still the active one (a plain property read still works through the
    // disconnected scope's prototype chain) instead of relying on cleanup.
    // ========================================

    // Paused while Consolidated Stats or Metrics Explorer is open (see
    // openConsolidatedStatsDialog/openMetricsExplorerDialog below) — both
    // run their own refresh/fetches against the single interceptor being
    // viewed, and letting this list-level refresh keep firing underneath
    // them just wastes a request every tick for no visible benefit.
    $scope._listRefreshPaused = false;

    var autoRefreshTimer = $interval(function () {
        if ($scope.selectedTabIndex !== 7) { return; }
        if ($scope._listRefreshPaused) { return; }
        if ($scope.profile && $scope.profile.id && $scope._bizInterceptorsLoadedOnce) {
            $scope.loadBizInterceptors(true);
        }
    }, ConfigurationService.getFromCache('frontend.biz_interceptors_refresh_interval') || 10000);

    // ========================================
    // AUTO-LOAD al entrar al tab
    // ========================================

    function safeInitialLoad() {
        if (!$scope.profile || !$scope.profile.id) { return; }
        if (!$scope._bizInterceptorsLoadedOnce) {
            $scope._bizInterceptorsLoadedOnce = true;
            $scope.loadBizInterceptors();
        }
    }

    $timeout(function () { safeInitialLoad(); }, 0);

    $scope.$on('biz-interceptors:tab-selected', function () {
        if (!$scope._bizInterceptorsLoadedOnce) {
            safeInitialLoad();
        } else {
            $scope.loadBizInterceptors();
        }
    });

    $scope.$watch('profile.id', function (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
            $scope._bizInterceptorsLoadedOnce = false;
            safeInitialLoad();
        }
    });

});

// ============================================================
// DIRECTIVE: biInlineFocus — auto-focuses input when condition
// is truthy (used by inline-edit cells in the biz-interceptors table)
// ============================================================
angular.module('bizmetryApp').directive('biInlineFocus', function ($timeout) {
    return {
        restrict: 'A',
        scope: { biInlineFocus: '=' },
        link: function (scope, element) {
            scope.$watch('biInlineFocus', function (val) {
                if (val) {
                    $timeout(function () {
                        element[0].focus();
                        element[0].select();
                    }, 30);
                }
            });
        }
    };
});
